import { Card } from '../../components/ui/card';
import { Target, IndianRupee, AlertTriangle, Users, CalendarCheck, Wallet } from 'lucide-react';

export const inr = n => (n == null || Number.isNaN(n) ? '—' : `${n < 0 ? '−' : ''}₹${Math.abs(Math.round(n * 100) / 100).toLocaleString('en-IN')}`);
export const nc = v => (v == null ? <span className="text-slate-300" title="Not captured (back-filled day)">n/c</span> : v);

export const IsaKpis = ({ data, isDay }) => {
  const t = data.totals;
  const cards = [
    { label: isDay ? 'Team Hot leads' : 'Team Hot leads (month)', value: t.team_hot, sub: isDay ? `target ${data.rules.target}` : `${t.days} day(s) saved`, icon: Target, tint: 'bg-blue-50 text-blue-600' },
    { label: 'Target met', value: `${t.met_days}/${t.days}`, sub: `${t.missed_days} day(s) below ${data.rules.target}`, icon: CalendarCheck, tint: 'bg-emerald-50 text-emerald-600' },
    { label: 'Team incentive', value: inr(t.incentive), sub: `₹${data.rules.rate} per Hot lead on target days`, icon: IndianRupee, tint: 'bg-emerald-50 text-emerald-600' },
    { label: 'Penalties', value: inr(t.penalties), sub: 'counted once per day, team level', icon: AlertTriangle, tint: 'bg-rose-50 text-rose-600' },
    { label: 'Net team amount', value: inr(t.net), sub: 'incentive − penalties', icon: Wallet, tint: t.net < 0 ? 'bg-rose-50 text-rose-600' : 'bg-slate-100 text-slate-700', strong: t.net < 0 ? 'text-rose-600' : 'text-slate-900' },
    { label: 'Payout shares', value: data.employees.filter(e => data.people[e.key]).map(e => `${e.name} ${inr(data.people[e.key].share)}`).join(' · '),
      sub: data.employees.filter(e => data.people[e.key]).map(e => `${e.name} ${data.people[e.key].hot} Hot (${data.people[e.key].contribution_pct}%)${e.share_pct != null ? `, ${e.share_pct}% split` : ''}`).join(' · '),
      icon: Users, tint: 'bg-violet-50 text-violet-600', small: true },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-6 gap-3" data-testid="isa-kpis">
      {cards.map(k => (
        <Card key={k.label} className="p-4" data-testid={`isa-kpi-${k.label.toLowerCase().replace(/[^a-z]+/g, '-')}`}>
          <div className={`w-8 h-8 rounded-lg flex items-center justify-center mb-2 ${k.tint}`}><k.icon className="w-4 h-4" /></div>
          <div className="text-[10px] uppercase tracking-wider text-slate-400 font-semibold">{k.label}</div>
          <div className={`${k.small ? 'text-sm' : 'text-xl'} font-bold mt-0.5 ${k.strong || 'text-slate-900'}`}>{k.value}</div>
          <div className="text-[11px] text-slate-500 mt-0.5 leading-snug">{k.sub}</div>
        </Card>
      ))}
    </div>
  );
};

export const PenaltyBreakdown = ({ data }) => (
  <Card className="p-4" data-testid="isa-penalty-breakdown">
    <h3 className="text-sm font-bold text-slate-900">Penalty breakdown</h3>
    <p className="text-[11px] text-slate-500 mb-3">Team totals only — each rule can trigger at most once a day.</p>
    <div className="space-y-2">
      {data.penalty_breakdown.map(p => (
        <div key={p.key} className="flex items-center gap-3 text-xs" data-testid={`isa-penalty-${p.key}`}>
          <span className="flex-1 text-slate-700">{p.label}</span>
          <span className="text-slate-500 w-20 text-right">{p.days} day(s)</span>
          <span className={`w-24 text-right font-semibold ${p.amount ? 'text-rose-600' : 'text-slate-400'}`}>{inr(-p.amount)}</span>
        </div>
      ))}
      <div className="flex items-center gap-3 text-xs border-t border-slate-100 pt-2 font-bold">
        <span className="flex-1 text-slate-900">Total penalties</span>
        <span className="w-24 text-right text-rose-600">{inr(-data.totals.penalties)}</span>
      </div>
    </div>
  </Card>
);
